module.exports = __webpack_public_path__ + "img/pp_logo_3_cleaner.1b7991a0.svg";